import type { SlackContainerComponent } from './slack-container.component';

export type SlackContainerComponentT = new (...args: any[]) => SlackContainerComponent;

export const SlackComponentLoader: () => Promise<SlackContainerComponentT> = () =>
  import('./slack-container.component').then(k => k.SlackContainerComponent);
